import _ from 'lodash';

import { State } from '../../../setup/types';

export const shouldShowFleetDialog = (state?: State) =>
    _.get(state, 'fleetAssistant.showFleetDialog', false);
